/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import FormValidations from 'cio/utils/form-validations';

import SegmentModel from 'cio/models/segment';
import TagModel from 'cio/models/tag';

enum SegmentType {
  Static = 'static',
  Dynamic = 'dynamic',
}

const Validations = {
  name(value?: string) {
    if (isEmpty(value?.trim() ?? '')) {
      return "Name can't be blank";
    }

    return true;
  },
};

interface DetailsArgs {
  isSaving: boolean;
  segment: SegmentModel;
  next: () => void;
}

export default class Details extends Component<DetailsArgs> {
  validations: FormValidations;

  @computed('validations.{isTouched,hasErrors}', 'args.isSaving')
  get saveDisabled() {
    let {
      args: { isSaving },
      validations: { isTouched, hasErrors },
    } = this;
    return !isTouched || hasErrors || isSaving;
  }

  @action
  chooseType(type: SegmentType) {
    this.args.segment.set('type', type);
    this.args.next();
  }
  @action
  addTag(tag: TagModel) {
    let { segment } = this.args;

    segment.set('tags', [...(segment.tags.content as TagModel[]), tag]);
  }
  @action
  removeTag(tag: TagModel) {
    let { segment } = this.args;

    segment.set(
      'tags',
      (segment.tags.content as TagModel[]).filter((t) => t !== tag),
    );
  }

  @action
  onNameChange(name: string) {
    this.args.segment.set('name', name);
    this.validations.validateAttribute('name');
  }

  constructor(owner: unknown, args: DetailsArgs) {
    super(owner, args);

    this.validations = FormValidations.create({
      validations: Validations,
      context: this,
      modelKey: 'args.segment',
    });
  }
}
